import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Ce que partagent les écrans du départ (Yros/Kavero#62) : le style des
 * champs, et l'état d'un départ en pastille.
 */
export const CLASSE_CHAMP = 'mt-1 w-full px-4 py-2 border rounded-lg text-gray-700 bg-gray-50 font-medium text-sm';

export const CARTE = 'bg-white p-4 sm:p-6 rounded-2xl shadow-sm border border-slate-100';

// États du contrat C34. Couleurs neutres ou de statut, jamais le violet de daisyUI.
const COULEURS_ETAT = {
  brouillon: 'bg-gray-100 text-gray-700',
  lance: 'bg-blue-50 text-blue-700',
  stc_valide: 'bg-amber-50 text-amber-700',
  clos: 'bg-green-50 text-green-700',
  annule: 'bg-red-50 text-red-700',
};

export function EtatDepart({ etat }) {
  const { t } = useTranslation();
  return (
    <span data-testid="depart-etat"
      className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${COULEURS_ETAT[etat] || COULEURS_ETAT.brouillon}`}>
      {t(`departs.etats.${etat}`, { defaultValue: etat })}
    </span>
  );
}

// Les montants du STC sont dans la devise de la société ; le portail affiche
// comme ailleurs en francs CFA, sans décimale.
export const montant = (valeur) =>
  new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Number(valeur) || 0);
